import React from "react";
import useCartState from "src/core/checkout/hooks/useCartState";
import useOrderState from "src/core/checkout/hooks/useOrderState";
import DisableIf from "../../common/components/utils/DisableIf";

function DisableIfLoading({children}) {
  const [cartState] = useCartState();
  const [orderState] = useOrderState();

  const loading = cartState.loading || orderState.loading;
  return <DisableIf disabled={loading}>{children}</DisableIf>;
}

export default DisableIfLoading;
